import type { StyleSystemProps } from '@withjoy/joykit';
import { Flex, styled, Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledWrapper = styled(Flex)``;
const wrapperStyles: StyleSystemProps = {
  marginBottom: pxToRem(80),
  height: { _: pxToRem(150), sm2: pxToRem(100) },
  justifyContent: 'center',
  position: 'relative',
};

export const StyledCardWrapper = styled(Flex)``;
const cardWrapperStyles: StyleSystemProps = {
  maxWidth: pxToRem(800),
  width: '100%',
  flexDirection: 'column',
  position: 'relative',
};

export const StyledCardContent = styled(Flex)``;
const cardContentStyles = (isOpen: boolean): StyleSystemProps => ({
  minHeight: '100%',
  alignItems: 'center',
  paddingX: 6,
  transition: 'border 300ms',
  border: isOpen ? '1px solid' : 'none',
  borderColor: 'mono3',
  borderBottom: 'none',
  borderRadius: pxToRem(8),
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
});

export const StyledDropdownContent = styled(Flex)``;
const dropdownContentStyles = (isOpen: boolean): StyleSystemProps => ({
  backgroundColor: 'white',
  zIndex: 3,
  transition: 'min-height 300ms, border 300ms',
  minHeight: isOpen ? { _: pxToRem(420), sm2: pxToRem(240) } : pxToRem(1),
  overflow: 'hidden',
  borderBottomLeftRadius: pxToRem(8),
  borderBottomRightRadius: pxToRem(8),
  border: isOpen ? '1px solid' : 'none',
  borderColor: 'mono3',
  borderTop: 'none',
});

export const ExpandButtonContainer = styled(Box)``;
export const StyledToggleButton = styled(Flex)``;
const expandButtonStyles = (isOpen: boolean): StyleSystemProps => ({
  width: pxToRem(32),
  height: pxToRem(32),
  border: 'solid 2px #e5e5e5',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'background-color 300ms, border-color 300ms, transform 500ms',
  transform: isOpen ? 'rotate(-180deg)' : 'rotate(0deg)',
  _hover: {
    backgroundColor: 'rgba(89, 89, 89, 0.05)',
    borderColor: 'mono5',
  },
  _active: {
    backgroundColor: 'rgba(77, 77, 77, 0.1)',
    borderColor: 'mono7',
  },
});

export const StyledDivider = styled(Box)``;
const dividerStyles: StyleSystemProps = {
  width: '100%',
  height: '1px',
  position: 'absolute',
  bottom: 0,
  zIndex: 5,
  borderBottom: '1px solid',
  color: 'mono3',
};

export const styles = {
  wrapper: wrapperStyles,
  cardWrapper: cardWrapperStyles,
  cardContent: cardContentStyles,
  dropdownContent: dropdownContentStyles,
  expandButton: expandButtonStyles,
  divider: dividerStyles,
};
